function SSOLogin() {
  return null;
}

export default SSOLogin;
